<template>
    <v-navigation-drawer v-model="drawerModel" fixed app color="primary" :mini-variant="miniVariant" dark>
        <v-img src="logo-small.png" v-if="miniVariant">
        </v-img>
        <v-row class="mr-8 ml-8 mt-4" v-if="!miniVariant">
            <v-col>
                <v-img :aspect-ratio="16/9" src="logo-no-adp.png">
                </v-img>
            </v-col>
        </v-row>

        <v-list nav>
            <template v-if="!currentUserID">
                <v-list-item link to="/register">
                    <v-list-item-icon>
                        <v-icon>fa-user-plus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Register</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/login">
                    <v-list-item-icon>
                        <v-icon>fa-sign-in-alt</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Sign In</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
            <template v-else>
                <v-list-item link v-if="isAdmin" to="/firms">
                    <v-list-item-icon>
                        <v-icon>fa-building</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Firms</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/admin/clients" v-if="isAdmin">
                    <v-list-item-icon>
                        <v-icon>fa-address-book</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Client Management</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/clients" v-else>
                    <v-list-item-icon>
                        <v-icon>fa-address-book</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Client Management</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/marketing">
                    <v-list-item-icon>
                        <v-icon>fa-funnel-dollar</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Marketing</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/users" v-if="isAdmin">
                    <v-list-item-icon>
                        <v-icon>fa-users</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Users</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/support">
                    <v-list-item-icon>
                        <v-icon>fa-question-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Support</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="$emit('confirm-logout')">
                    <v-list-item-icon>
                        <v-icon>fa-sign-out-alt</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Log Out</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
            
        
        </v-list>
    </v-navigation-drawer>
</template>

<script>

    export default {
        name: 'navigation',
        props: [ 'drawer' ],
        data: () => ({
            drawerModel: false,
            miniVariant: false,
        }),
        computed: {

        },
        methods: {
            toggleDrawer(){
                if( ! this.isMobile ){
                    this.miniVariant = !this.miniVariant
                } else {
                    this.drawerModel = !this.drawerModel
                }
            }
        },
        created(){
            if( ! this.isMobile ){
                this.drawerModel = true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .v-list-item {
        color: #7992a0;
    }
</style>